import { shape, string, oneOfType, number, arrayOf } from "prop-types"
import QuestionForm from "./QuestionForm"
import { navigate } from "@reach/router"

const EditQuestion = ({
  location: { state: { kind } = {} },
  questions = [],
  questionId,
  basePath,
  ...props
}) => {
  const question = questions.find(question => question.id == questionId)

  if (!question) {
    navigate(basePath)
    return null
  }

  return (
    <QuestionForm
      {...props}
      basePath={basePath}
      question={question}
      sectionHeaderKind={kind || question.kind === "section_header"}
      editing={true}
    />
  )
}

EditQuestion.propTypes = {
  basePath: string.isRequired,
  location: shape({
    state: shape({
      kind: string
    })
  }),
  questionId: oneOfType([number, string]),
  questions: arrayOf(shape({ id: oneOfType([number, string]) }))
}

export default EditQuestion
